<template>
    <v-tabs v-if="isMobile" v-model="mobileTabs" stacked fixed-tabs class="sticky-bar">
        <v-tab v-for="tab in tabs" :key="tab.label">
            {{ isMobile ? $t(`${tab.label}`) : '' }}
            <v-icon>{{ tab.icon }}</v-icon>
        </v-tab>
    </v-tabs>
</template>

<script lang="ts">
    import {Vue, Component, VModel} from 'vue-facing-decorator'

    @Component
    export class HotelInfoMobileTabs extends Vue {
        @VModel() mobileTabs

        get tabs() {
            return [
                {icon: 'mdi-office-building', label: 'hotel'},
                ...(this.$route.name !== 'hotelInfo' ? [{icon: 'mdi-bed', label: 'offers'}] : []),
                {icon: 'mdi-map-marker', label: 'map'},
            ]
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default HotelInfoMobileTabs
</script>
